export default "__VITE_ASSET__wNFDUZO9__"